module.exports = __webpack_public_path__ + "static/tjapp-2e370af45c1000e1e64427b7ad29183c.jpg";